// src/services/api.js
import axios from "axios";
import { getAuth } from "firebase/auth";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000, // 30 second timeout
});

// Add token to requests
api.interceptors.request.use(
  async (config) => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        const token = await user.getIdToken(true); // Force refresh token
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    } catch (error) {
      console.error("Error getting auth token:", error);
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with error status
      console.error("API Error:", error.response.status, error.response.data);

      if (error.response.status === 401) {
        // Unauthorized - handle token refresh or redirect to login
        console.log("🔐 Unauthorized - redirecting to login");
        // You could redirect to login here
      }

      if (error.response.status === 403) {
        // Forbidden
        console.error("🚫 Forbidden - insufficient permissions");
      }

      if (error.response.status === 429) {
        // Too many requests
        console.error("⏳ Rate limit exceeded - please wait");
      }
    } else if (error.request) {
      // Request made but no response
      console.error("🌐 No response from server:", error.message);

      if (!navigator.onLine) {
        console.warn(
          "📶 You appear to be offline - please check your connection",
        );
      }
    } else {
      // Something else happened
      console.error("❌ API Error:", error.message);
    }

    return Promise.reject(error);
  },
);

// Helper to check if we're online
export const isOnline = () => navigator.onLine;

export default api;
